import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toast } from "@capacitor/toast";


import "./../../../theme/theme-consumer14.css";
import { ErrorMessage } from "@hookform/error-message";
import FormHeader from "../../../push-components/FormHeader/FormHeader";
import { authActions } from "../../../store/auth";
import ProgressBar from "../../../push-components/ProgressBar/ProgressBar";
import {
  adjustBorderHeight,
  getQrCodeInfo,
  getUserCameraPhoto,
  getUserCurrentPosition,
  setTalnetInfoInReduxStore,
  showToastMessage,
  storeScannedCampaign,
} from "../../../common/common";
import {
  validatePhoto,
  validatePhoneNumber,
  formatPhoneNumber,
  offlineErrorCode,
  somethingWentWrongErrMsg,
} from "../../../common/common";
import { getAppVersion } from "../../../data-services/general";
import {
  getStatesForSignUp,
  isMobileNumberValid,
  sendSignupDataToApi,
  isEmailAddressValid,
  getPoliciesContent,
  getTalentZipcode,
  generateTextVerificationCode,
  checkTextVerificationCode,
  generateEmailVerificationCode,
  checkEmailVerificationCode,
} from "../../../data-services/signup";
import moment from "moment";
import refesh_icon from "../../../assets/images/signup/img/reload.png";
import edit_icon from "../../../assets/images/signup/img/edit.png";
import take_selfie_eg1 from "../../../assets/images/signup/img/take-selfie-example-1.png";
import take_selfie_eg2 from "../../../assets/images/signup/img/take-selfie-example-2.png";
import take_selfie_eg3 from "../../../assets/images/signup/img/take-selfie-example-3.png";
import locatin_icon from "../../../assets/images/signup/img/icon-location.png";
import check_icon from "../../../assets/images/common/checked.png";
import PolicyModal from "../policyModal/policyModal";
import AvatarFileUploader from "../../../push-components/ProfileFileuploader/AvatarFileUploader";
import { isPlatform } from "@ionic/core";
import { async } from "@firebase/util";
import { talentFileUploader, logError } from "../../../data-services/assignmets";
import { get } from "../../../storage/storage";

const eye = <FontAwesomeIcon icon={faEye} />;
const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />;
var initialScreenSize = window.innerHeight;
const QR14BeachLeashSignup: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [show_section, set_show_section] = useState({
    signup_step: 1,
    progress_bar: 0.1,
  });
  const [isValidPhone, setIsValidPhone] = useState<boolean>(false); // true if phone number is valid
  const [isTermschecked, setIsTermsChecked] = useState<boolean>(false); //checke is terms privacy policy
  const [isReceivePushSMS, setIsReceivePushSMS] = useState<boolean>(true);
  const [isReceivePushEmail, setIsReceivePushEmail] = useState<boolean>(true);
  const [passwordShown, setPasswordShown] = useState(false);
  const [isValidEmailId, setIsValidEmailId] = useState<boolean>(false);
  const [signupStateList, setSignupStateList] = useState<any>([]);
  const [generatedTalentDisplyName, setGeneratedTalentDisplyName] =
    useState<string>();
  // mobile section btn endabled/disabled
  const [mobileSecBtn, setMobileSecBtn] = useState<boolean>(false);
  // personal info btn
  const [personalInfoSecBtn, setPersonalInfoSecBtn] = useState<boolean>(false);
  // email section btn
  const [emailSecBtn, setEmailSecBtn] = useState<boolean>(false);
  // zipcode section btn
  const [zipcodeSecBtn, setZipcodeSecBtn] = useState<boolean>(false);
  const [signupError, setSignupError] = useState<any>("");
  // get current location btn
  const [getLocationBtn, setGetLocationBtn] = useState<boolean>(false);
  //
  const [selfieImage, setSelfieImage] = useState<any>("");

  const [ispwdlowercase, setIspwdlowercase] = useState(false);
  const [ispwduppercase, setIspwduppercase] = useState(false);
  const [ispwdnumeric, setIspwdnumeric] = useState(false);
  const [ispwdlength, setIspwdlength] = useState(false);

  // terms and privacy policy modal state
  const [showPolicyModal, setShowPolicyModal] = useState<boolean>(false);
  const [policiesContent, setPoliciesContent] = useState<any>("");
  const [policiesTitle, setPoliciesTitle] = useState<string>("");
  // birth date default input type
  const [birthDateInputType, setBirthDateInputType] = useState<string>("");
  const [showphotoloading, setShowPhotoLoading] = useState<boolean>(false);
  const [showPhotoValidateAlert, setShowPhotoValidateAlert] =
    useState<boolean>(false);
  const [showPhotoValidateMessage, setShowPhotoValidateMessage] =
    useState<any>("");
  
  // Loading and upload progress states
  const [loading, setLoading] = useState<boolean>(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const contentRef = useRef<HTMLIonContentElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    setTimeout(() => {
      if (!show_section || show_section?.signup_step == 1) {
        adjustBorderHeight(730);
      }
    }, 100);
  }, []);

  
  useEffect(() => {
    // Readjust the border height when the step changes
    if (show_section.signup_step == 2) {
      adjustBorderHeight(630);
      contentRef.current?.scrollToTop(0);
    }
    
  }, [show_section]);

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      talent_mobile: "",
      talent_terms: false,
      talent_mobile_otp: "",
      promotion_text_msg: false,
      talent_fname: "",
      talent_lname: "",
      talent_display_name: "",
      talent_gender: "",
      talent_birth_date: "",
      talent_address: "",
      talent_apartment_no: "",
      talent_city: "",
      talent_country: "",
      talent_state: "",
      talent_email: "",
      marketing_emails: false,
      talent_passowrd: "",
      talent_zipcode: "",
    },
    mode: "onBlur",
  });

  const validation = (event: any, type: any) => {
    var re1 = new RegExp("(?=.*[A-Z])");
    var re2 = new RegExp("(?=.*[a-z])");
    var re3 = new RegExp("(?=.*[0-9])");

    if (re1.test(event.target.value)) {
      setIspwduppercase(true);
    } else {
      setIspwduppercase(false);
    }
    if (re2.test(event.target.value)) {
      setIspwdlowercase(true);
    } else {
      setIspwdlowercase(false);
    }
    if (re3.test(event.target.value)) {
      setIspwdnumeric(true);
    } else {
      setIspwdnumeric(false);
    }
    if (event.target.value.length >= 8) {
      setIspwdlength(true);
    } else {
      setIspwdlength(false);
    }
  };

  function showSelfieSection() {
    backStepHandle();
    setSelfieImage("");
    set_show_section({
      signup_step: 8,
      progress_bar: 0.8,
    });
  }

  const nextStepHandler = async () => {
    if (Object.keys(errors).length === 0) {
      //  check if there any validations error
      let next_step = show_section.signup_step + 1;
      let increase_bar = show_section.progress_bar + 0.1;
      set_show_section({
        signup_step: next_step,
        progress_bar: increase_bar,
      });
    }
  };
  const backStepHandle = async () => {
    let back_step = show_section.signup_step - 1;
    if (back_step) {
      let decrease_bar = show_section.progress_bar - 0.1;
      set_show_section({
        signup_step: back_step,
        progress_bar: decrease_bar,
      });
      setSelfieImage(""); //set empty take selft state
    } else {
      history.push("/Notifications");
    }
  };
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const isSubmittingRef = useRef(false);
  const singupFormHandler = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    try {
    if (show_section.signup_step === 1) {
      if (!isTermschecked) {
        setError("talent_terms", {
          type: "manual",
          message: "This field is required.",
        });
        return;
      }

      if (qrDetails?.signupFields?.phone.enabled === true) {
        setMobileSecBtn(true);
        let is_valid_mobile = await isMobileNumberValid(
          getValues("talent_mobile")
        ); // only passing inital 14 letter to api (213) 123-2132
        if (is_valid_mobile?.success) {
          let text_varification: any = await generateOTP(
            getValues("talent_mobile")
          );
          if (text_varification?.success) {
            nextStepHandler();
          } else {
            let error_msg = "";
            if (text_varification?.data?.errorCode == 0) {
              error_msg = text_varification?.data?.message;
            } else {
              error_msg = text_varification.message;
            }
            setError("talent_mobile", {
              type: "manual",
              message: error_msg,
            });
            showToastMessage(error_msg);
          }
          setMobileSecBtn(false);
        } else {
          setError("talent_mobile", {
            type: "manual",
            message: is_valid_mobile.message,
          });
          showToastMessage(is_valid_mobile.message);
          setMobileSecBtn(false);
        }
      }

      let hasEmail = getValues("talent_email");
      if (qrDetails?.signupFields?.email.enabled === true) {
        let is_valid_email = await isEmailAddressValid(
          getValues("talent_email")
        );
        if (is_valid_email?.success) {
          await generateOTPEmail(
            getValues("talent_email")
          );
          nextStepHandler();
        } else {
          let error_msg = "";
          if (is_valid_email?.data?.errorCode == 0) {
            error_msg = is_valid_email?.data?.message;
          } else {
            error_msg = is_valid_email.message;
          }
          setError("talent_email", {
            type: "manual",
            message: error_msg,
          });
          showToastMessage(error_msg);
        }
      }

    } else if (show_section.signup_step === 2) {
      setMobileSecBtn(true);

      if (qrDetails?.signupFields?.phone.enabled === true) {
        let verify_otp = await checkTextVerificationCode(
          getValues("talent_mobile"),
          getValues("talent_mobile_otp")
        );
        if (verify_otp?.success) {
          // SUBMIT HERE!!!
          await onSubmitSignupForm();
        } else {
          setError("talent_mobile_otp", {
            type: "manual",
            message: verify_otp.message,
          });
        }
      }

      if (qrDetails?.signupFields?.email.enabled === true) {
        let verify_otp = await checkEmailVerificationCode(
          getValues("talent_email"),
          getValues("talent_mobile_otp")
        );
        if (verify_otp?.success) {
          // SUBMIT HERE!!!
          await onSubmitSignupForm();
        } else {
          setError("talent_mobile_otp", {
            type: "manual",
            message: verify_otp.message,
          });
        }
      }

      setMobileSecBtn(false);
    }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  const onSubmitSignupForm = async () => {
    setUploadProgress(5);
    setLoading(true);
    setZipcodeSecBtn(true);
    setSignupError("");
    const apiVersion = await getAppVersion();
    let versionFromTheAPI;
    let versionFromTheApplication;
    if (isPlatform("mobileweb") || isPlatform("desktop")) {
      versionFromTheAPI = "WEB";
      versionFromTheApplication = "WEB";
    } else if (isPlatform("ios")) {
      versionFromTheAPI = apiVersion.ios;
      versionFromTheApplication = process.env.REACT_APP_VERSION_IOS;
    } else if (isPlatform("android")) {
      versionFromTheAPI = apiVersion.android;
      versionFromTheApplication = process.env.REACT_APP_VERSION_ANDROID;
    }

    let signupInfoObject = {
      model_mobile: getValues("talent_mobile").trim(),
      model_phone: getValues("talent_mobile").trim(),
      model_receive_mail_alert: isReceivePushSMS ? "yes" : "no",
      model_fname: getValues("talent_fname").trim(),
      model_lname: getValues("talent_lname").trim(),
      model_email: getValues("talent_email").trim(),
      isPushTalentMobile: "1",
      model_city: "0",
      model_suit_size_id: "0",
      model_neck_size_id: "0",
      model_chest_id: "0",
      model_waist_id: "0",
      model_bust_size_id: "0",
      model_hip_size: "0",
      model_dress_size_id: "0",
      model_bust_cup_id: "0",
      model_weight: "0",
      model_eye_color: "0",
      model_primary_language: "English",
      model_show_size: "0",
      model_intrest_ar: "0",
      model_looks_as_ar: "0",
      model_ethnicity_ar: "0",
      model_business_aptitude: "0",
      model_sales_aptitude: "0",
      model_speaking_capability: "0",
      model_min_hourly_rate: "0",
      model_min_flat_rate: "0",
      user_comes_from: "{ue_id:"+qrDetails?.eventId+",model_user_id:"+qrDetails?.modelUserId+"}",
      model_recruiter_agent_user_id: "0",
      versionFromTheApplication: versionFromTheAPI,
      versionFromTheAPI: versionFromTheApplication,
      uuid: localStorage.getItem('uuid')
    };

    let singup_api_response = await sendSignupDataToApi(signupInfoObject);

    try {
      if (singup_api_response?.success) {
        let user_token = singup_api_response.authData.data.user_token;
        dispatch(
          authActions.login(
            setTalnetInfoInReduxStore(singup_api_response.authData.data)
          )
        );
      } else {
        if (singup_api_response?.data?.errorCode == offlineErrorCode) {
          await showToastMessage(singup_api_response?.data?.message);
          setSignupError(singup_api_response?.data?.message);
        } else if (singup_api_response?.message) {
          showToastMessage(singup_api_response.message);
          setSignupError(singup_api_response.message);
        } else {
          showToastMessage(somethingWentWrongErrMsg);
          setSignupError(somethingWentWrongErrMsg);
        }
      }
    } catch (e: any) {
      showToastMessage(
        "Something went wrong, please try again! Our technical team has been notified."
      );
      setSignupError(
        "Something went wrong, please try again! Our technical team has been notified."
      );

      await logError(
        "Signup - onSubmitSignupForm - Exception thrown",
        "Talent App - Signup",
        JSON.stringify(e.message)
      );

      setLoading(false);
      setUploadProgress(0);
      return;
    }

    // Mark campaign as attended now that signup succeeded
    storeScannedCampaign(`campaign_14`, qrDetails?.eventId, undefined);

    // After signup, redirect to the Success page
    window.location.href=`/QR14BeachLeashSuccess`;
    
    setLoading(false);
    setUploadProgress(0);
  };

  const handleProgress = (progressEvent: any) => {
    const progress = Math.round(
      (progressEvent.loaded / progressEvent.total) * 100
    );
    setUploadProgress(progress);
  };

  const closePolicyModal = () => {
    setShowPolicyModal(false);
  };
  const getPoliciesAndTerms = async (
    policy_type: string,
    policy_title: string
  ) => {
    let policy_api = await getPoliciesContent(policy_type);
    if (policy_api?.success) {
      setShowPolicyModal(true);
      setPoliciesTitle(policy_title);
      setPoliciesContent(policy_api.data);
    } else {
      if (policy_api?.data?.errorCode == 0) {
        showToastMessage(policy_api?.data?.message);
      }
    }
  };

  const openGoogleDocPopup = (googleDocUrl: string, title: string = "Document") => {
    // Create iframe HTML to embed the Google Doc
    const iframeContent = `
      <div style="height: 100vh; width: 100%; position: relative;">
        <iframe 
          src="${googleDocUrl}" 
          width="100%" 
          height="100%" 
          frameborder="0" 
          style="border: none; position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          allowfullscreen>
        </iframe>
      </div>
    `;
    
    // Open the modal with the embedded Google Doc
    setShowPolicyModal(true);
    setPoliciesTitle(title);
    setPoliciesContent(iframeContent);
  };
  const checkIsEmailValid = (event: any) => {
    // check is email valid and show checked icon on input field
    let regexp = /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\s*$/i;
    setIsValidEmailId(regexp.test(event.target.value));
  };
  const usePhotoGallery = async () => {
    let image = await getUserCameraPhoto("base64");
    if (image?.base64String) {
      setSelfieImage([
        {
          name: "user_selfie.jpg",
          type: "image/jpeg",
          size: 789,
          file: "data:text/plain;base64," + image.base64String,
          base64: image.base64String,
          data: {},
        },
      ]);
    }
  };

  const getTalentCurrentPosition = async () => {
    setGetLocationBtn(true);
    const { latitude, longitude }: any = await getUserCurrentPosition();
    if (latitude && longitude) {
      let talent_zipcode = await getTalentZipcode(latitude, longitude);
      if (talent_zipcode?.success) {
        setValue("talent_zipcode", talent_zipcode.data.zipcode);
      } else {
        await Toast.show({
          text:
            talent_zipcode?.data?.errorCode == 0
              ? talent_zipcode?.data?.message
              : "Unable to fetch zipcode ",
        });
      }
    }
    setGetLocationBtn(false);
  };

  const formatAndSetPhoneNumber = (event: any) => {
    let phone_no = event.target.value;

    let formatted_no = formatPhoneNumber(phone_no);

    if (formatted_no) {
      setValue("talent_mobile", formatted_no);
      setIsValidPhone(validatePhoneNumber(formatted_no));
      return;
    } else {
      setIsValidPhone(false);
    }
  };

  const getStateListBaseOnCountry = async (country: string) => {
    setSignupStateList(await getStatesForSignUp(country));
  };

  const generateOTP = async (number: string) => {
    let text_varification: any = await generateTextVerificationCode(number, qrDetails?.eventQrId);
    return text_varification;
  };

  const generateOTPEmail = async (email: string) => {
    let text_varification: any = await generateEmailVerificationCode(email, qrDetails?.eventQrId);
    return text_varification;
  };

  const validateRequiredField = (value: any) => {
    // Trim the value to check if it's only white spaces
    if (value.trim() === "") {
      return "This field is required.";
    }
    return true; // Return true if validation passes
  };

  

  useEffect(() => {
    let headshot_image: any = document.querySelector("#talend_selfie");
    if (headshot_image) {
      headshot_image.addEventListener("click", (event: any) => {
        let files = event.target.files;
      });
    }
  }, [isValidPhone, selfieImage]);

  return (
    <IonPage>
      {/* <FormHeader title="Sign Up" backStepHandle={backStepHandle} /> */}
      {/* <ProgressBar progress_value={show_section.progress_bar} /> */}
      <IonContent ref={contentRef} className={`lay__container--${qrDetails?.eventQrId} talent-signup-container talent-signup-step-${show_section.signup_step}`}>
        {typeof qrDetails != 'undefined' && 
          <div className={`lay__talent-signup--${qrDetails?.eventQrId} talent-signup`}>

            <form onSubmit={handleSubmit(singupFormHandler)}>

              {/* accepts mobile no section  */}
              { show_section.signup_step === 1 && (
                <section className="mobile talent-signup__section">

                  <div className="lay__background">
                    <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/Background1.png" />
                  </div>

                  {/* <div className="lay__background--border">
                    <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/Border.png" />
                  </div> */}
                  
                  <div className={`lay__content--${qrDetails?.eventQrId}`}>
                    <div className="img__first" style={{width: '90%', maxWidth: '300px'}}>
                      <div className="">
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/p1-img1.png" />
                      </div>
                    </div>
                    
                    {/* F Name */}
                    {qrDetails?.signupFields?.firstName.enabled === true &&
                      <div className="form-group">
                        <IonLabel className="form-group__label">
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/icon-name.png" style={{height: '12px', filter: 'brightness(0) saturate(100%) invert(12%) sepia(97%) saturate(6000%) hue-rotate(243deg) brightness(92%) contrast(107%)'}} /> Name
                        </IonLabel>

                        <input
                          type="text"
                          placeholder={qrDetails?.signupFields?.firstName.placeholder} 
                          className={
                            errors.talent_fname !== undefined
                              ? "login-input-styles-error"
                              : "form-group__input-styles"
                          }
                          {...register("talent_fname", {
                            required: "This field is required.",
                            validate: (value) => {
                              const v = (value || "").trim();
                              return (/^[A-Za-z ]+$/.test(v) && v.length >= 2) || "Please enter a valid name";
                            },
                          })}
                        ></input>
                        
                        <ErrorMessage
                          errors={errors}
                          name="talent_fname"
                          as={<div className="error-message" />}
                        />
                      </div>
                    }

                    {/* L Name */}
                    {false && qrDetails?.signupFields?.lastName.enabled === true &&
                      <div className="form-group">
                      <IonLabel className="form-group__label">
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/icon-name.png" style={{height: '12px', filter: 'brightness(0) saturate(100%) invert(12%) sepia(97%) saturate(6000%) hue-rotate(243deg) brightness(92%) contrast(107%)'}} /> last name
                      </IonLabel>

                      <input
                        type="text"
                        placeholder={qrDetails?.signupFields?.lastName.placeholder}
                        className={
                          errors.talent_lname !== undefined
                            ? "login-input-styles-error"
                            : "form-group__input-styles"
                        }
                        {...register("talent_lname", {
                          required: "This field is required.",
                          validate: (value) => {
                            const v = (value || "").trim();
                            return (/^[A-Za-z ]+$/.test(v) && v.length >= 2) || "Please enter a valid name";
                          },
                        })}
                      ></input>
                      
                      <ErrorMessage
                        errors={errors}
                        name="talent_lname"
                        as={<div className="error-message" />}
                      />
                      </div>
                    }

                    {/* Phone */}
                    {qrDetails?.signupFields?.phone.enabled === true &&
                      <div className="form-group">
                        <IonLabel className="form-group__label">
                        number
                        </IonLabel>

                        <input
                          type="tel"
                          placeholder={qrDetails?.signupFields?.phone.placeholder} 
                          className={
                            errors.talent_mobile !== undefined
                              ? "login-input-styles-error"
                              : "form-group__input-styles"
                          }
                          {...register("talent_mobile", {
                            required: "This field is required.",
                          })}
                          maxLength={14}
                          onInput={formatAndSetPhoneNumber}
                        ></input>
                        {isValidPhone && (
                          <img
                            className="talent-signup__check-icon"
                            src={check_icon}
                            alt=""
                          />
                        )}
                        <ErrorMessage
                          errors={errors}
                          name="talent_mobile"
                          as={<div className="error-message" />}
                        />
                      </div>
                    }

                    {/* Email */}
                    {qrDetails?.signupFields?.email.enabled === true &&
                      <div className="form-group"> 
                      <IonLabel className="form-group__label">
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/icon-email.png" style={{height: '10px', filter: 'brightness(0) saturate(100%) invert(12%) sepia(97%) saturate(6000%) hue-rotate(243deg) brightness(92%) contrast(107%)'}} /> Email
                      </IonLabel>
                      <input
                        type="text"
                        placeholder={qrDetails?.signupFields?.email.placeholder}
                        className={
                          errors.talent_email !== undefined
                            ? "form-input-styles-error"
                            : "form-group__input-styles"
                        }
                        {...register("talent_email", {
                          required: "This field is required.",
                          pattern: {
                            value:
                              /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\s*$/i,
                            message: "Invalid email address",
                          },
                        })}
                        onChange={(e: any) => checkIsEmailValid(e)}
                      ></input>
                      {isValidEmailId && (
                        <img
                          className="talent-signup__check-icon"
                          src={check_icon}
                          alt=""
                        />
                      )}

                      <ErrorMessage
                        errors={errors}
                        name="talent_email"
                        as={<div className="error-message" />}
                      />
                      </div>
                    }

                    <div className="section-footer" style={{marginTop: '0px'}}>
                      <div className="mobile__terms">
                        <div>
                          <IonLabel>
                            <div style={{textAlign: 'center'}}>
                              <IonCheckbox
                                className="form-group__checkbox-styles"
                                mode="md"
                                {...register("talent_terms", {
                                  required: "This field is required.",
                                })}
                                checked={isTermschecked}
                                onIonChange={(e) => setIsTermsChecked(e.detail.checked)}
                              ></IonCheckbox>

                            </div>
                            
                            By checking this box I provide my express written consent to receive recurring marketing
                            text messages from PUSH Agency on behalf of BEACH LEASH. Consent is not a condition of purchase. 
                            Msg & data rates may apply. Reply HELP for assistance and STOP to cancel.
                            I agree to PUSH Agency's&nbsp;
                            <a
                              onClick={() =>
                                openGoogleDocPopup(
                                   // General T&C
                                  "https://docs.google.com/document/d/1A5Vxn8MIoWXzkzMDGtw2q-_-PyXsqRNtETI0VD-PqME/preview",
                                  // Custom T&C
                                  // "https://docs.google.com/document/d/1A5Vxn8MIoWXzkzMDGtw2q-_-PyXsqRNtETI0VD-PqME/preview",
                                  "Terms of Service and Privacy Policy"
                                )
                              }
                            >
                              Terms of Service and Privacy Policy
                            </a>
                          </IonLabel>
                          <br />
                          <ErrorMessage
                            errors={errors}
                            name="talent_terms"
                            as={<div className="error-message" />}
                          />
                        </div>
                      </div>

                      <IonButton
                        expand="block"
                        mode="ios"
                        type="submit"
                        className="form__submit-img"
                        disabled={mobileSecBtn}
                      >
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/CTA-Submit1.png"/>
                      </IonButton>
                    </div>
                  </div>

                  {/* <div className="img__bottom">
                    <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/p1-bottom.png" style={{width: '100%'}} />
                  </div> */}
                </section>
              )}

              {/* opt section  */}
              {show_section.signup_step === 2 && (
                <section className="verification-code talent-signup__section">

                  <div className="lay__background">
                    <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/Background1.png" />
                  </div>
                  

                  {/* <div className="img__bottom">
                    <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                      <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/p2-bottom.png" />
                    </div>
                  </div> */}

                  {/* <div className="lay__background--border">
                    <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/Border.png" />
                  </div> */}

                  <div className={`lay__content--${qrDetails?.eventQrId}`}>
                    <div className="img__first" style={{marginBottom: '0px', marginTop: '150px', maxWidth: '250px'}}>
                      <div className="talent-signup__section-title">
                        <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/p2-img1.png" />
                      </div>
                    </div>

                    <div className="form-group" style={{marginTop: '20px'}}>
                      <input
                        style={{borderRadius: '15px', border: '1px solid #FA6700'}}
                        type="tel"
                        placeholder="#"
                        className={
                          errors.talent_mobile_otp !== undefined
                            ? "form-input-styles-error"
                            : "form-group__input-styles form-group__input-styles--border"
                        }
                        {...register("talent_mobile_otp", {
                          required: "This field is required.",
                          minLength: {
                            value: 4,
                            message: "Minimum 4 digits required.",
                          },
                          maxLength: {
                            value: 4,
                            message: "Max 4 digits allowed",
                          },
                        })}
                      ></input>
                      <ErrorMessage
                        errors={errors}
                        name="talent_mobile_otp"
                        as={<div className="error-message" />}
                      />

                      <div>
                        <IonButton
                          expand="block"
                          mode="ios"
                          type="submit"
                          className="form__submit-img"
                          disabled={mobileSecBtn}
                          style={{marginTop: '10px'}}
                        >
                          <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/CTA-Submit1.png" />
                        </IonButton>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </form>
          </div>}
      </IonContent>
      <IonAlert
        mode="ios"
        isOpen={showPhotoValidateAlert}
        onDidDismiss={() => setShowPhotoValidateAlert(false)}
        header={"Detect Human Face"}
        message={showPhotoValidateMessage}
        buttons={[
          {
            text: "Retake",
            handler: () => {
              showSelfieSection();
            },
          },
        ]}
      />
      <PolicyModal
        title={policiesTitle}
        heading={`heading`}
        description={policiesContent}
        isOpen={showPolicyModal}
        closeAction={closePolicyModal}
      />
    </IonPage>
  );
};

export default QR14BeachLeashSignup;
